var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#2C67F1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.00046C4.00018 2.23383 4.82758 1.75253 5.49414 2.13132L14.0225 6.97897L14.1377 7.05515C14.6786 7.46723 14.66 8.31574 14.0615 8.69382L5.53418 14.0796C4.86831 14.5001 4 14.0214 4 13.2339V3.00046ZM5 13.2339L13.5283 7.84811L5 3.00046V13.2339Z",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.d47ce0c6aa233ab97aaae5759d1326d5.svg";
export { ForwardRef as ReactComponent };